<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-body pt-2 w-100">
        <div class="row">
          <div class="col-xl-3 col-12">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </div>
          <div class="col-xl-2 col-12" [ngClass.sm]="'mt-1'">
            <select [(ngModel)]="searchStatus" class="form-control">
              <option value="7" selected>{{ "ALL" | translate }}</option>
              <option [value]="stepStatus.value" selected *ngFor="let stepStatus of step_status_filter">{{ stepStatus.name | translate }}</option>
            </select>
          </div>
          <div class="col-xl-3 col-12">
            <ng-select [(ngModel)]="recruiterFilter" [closeOnSelect]="true" [clearable]="!!recruiterFilter.hash" (clear)="recruiterFilter= {hash: null, complete_name: null}">
              <ng-template ng-label-tmp let-item="item">
                <span>{{ "RECRUITER" | translate }} : {{ item.complete_name || ('ALL' | translate) }}</span>
              </ng-template>
              <ng-option [value]="{hash: null, complete_name: null}">{{ "ALL" | translate }}</ng-option>
              <ng-option *ngFor="let recruiter of recruiterList" [value]="recruiter">{{ recruiter.complete_name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12" has_capability="proposed_candidate_view_others">
            <ng-select [closeOnSelect]="true" [openOnEnter]="true" [(ngModel)]="filterCommercial" [clearable]="!!filterCommercial.hash" (clear)="filterCommercial = {hash: null, complete_name: null}">
              <ng-template ng-label-tmp let-item="item">
                <span>{{ "CUSTOMER_COMMERCIAL" | translate }} : {{ item.complete_name || ('ALL' | translate) }}</span>
              </ng-template>
              <ng-option [value]="{hash: null, complete_name: null}">{{ 'ALL' | translate }}</ng-option>
              <ng-option *ngFor="let comm of commercialList" [value]="comm">{{ comm.complete_name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12">
            <span class="font-small-2">{{ "FROM" | translate }}</span>
            <app-datepickr displayMonths="1" [defaultDate]="filteredFrom" (onSelect)="filteredFrom = $event"></app-datepickr>
          </div>
          <div class="col-xl-3 col-12">
            <span class="font-small-2">{{ "TO" | translate }}</span>
            <app-datepickr displayMonths="1" [defaultDate]="filteredTo" (onSelect)="filteredTo = $event"></app-datepickr>
          </div>
          <div class="col-xl-3 col-12">
            <span class="font-small-2">&nbsp;</span>
            <ng-select [closeOnSelect]="true" [openOnEnter]="true" [(ngModel)]="filterRequest" [clearable]="filterRequest !== '0'" (clear)="filterRequest = '0'">
              <ng-template ng-label-tmp let-item="item">
                <span>{{ "REQUEST" | translate }} : {{ item === '0' ? ('ALL_FEMALE_PLURAL' | translate) : item }}</span>
              </ng-template>
              <ng-option value="0">{{ 'ALL_FEMALE_PLURAL' | translate }}</ng-option>
              <ng-option *ngFor="let req of requestsList" [value]="req">{{ req }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12">
            <span class="font-small-2">&nbsp;</span>
            <button class="d-block w-fit btn btn-outline-primary" (click)="loadEligibleCandidate()">{{'FILTER' | translate}}</button>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="50" [scrollbarH]="true" [rowHeight]="_utilService.isDesktop ? 70 : 190"
                       [limit]="tableLimit" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }" [footerHeight]="50" [rows]="filteredItems" [sorts]="[{ prop: 'data.insert_date', dir: 'desc' }]">
          <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="user.complete_name" width="140" sortable="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="row.user?.type_code === 'candidate' ? '/dashboard/candidate/edit/' + row.user.hash : '/dashboard/user/profile/' + row.user?.hash">{{ row.user.complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'REQUEST' | translate }}" prop="request_name" width="250" sortable="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="'/dashboard/detail-request/' + row.request_id">{{ row.request_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'RECRUITER' | translate }}" prop="data.creator_complete_name" width="150" sortable="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="'/dashboard/user/profile/' + row.data.creator_hash">{{ row.data.creator_complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'DATE' | translate }}" prop="data.insert_date" width="60" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.data.insert_date | date: 'dd/MM/yyyy HH:mm' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="data.step" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-{{ row.color_step }}" [ngbTooltip]="row.data.date ? _utilService.formatDate(row.data.date, 'DD/MM/YYYY HH:mm') : null">{{ row.label_step | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="user.complete_name" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row">
                <div class="col-12">
                  {{ "REQUEST" | translate }}: <a [routerLink]="'/dashboard/detail-request/' + row.request_id">{{ row.request_name }}</a>
                </div>
                <div class="col-12">
                  {{ "TITLES.USERS_TYPES_SINGULAR.candidate" | translate }}:
                  <a [routerLink]="row.user.type_code === 'candidate' ? '/dashboard/candidate/edit/' + row.user.hash : '/dashboard/user/profile/' + row.user.hash">{{ row.user.complete_name }}</a>
                </div>
                <div class="col-12">
                  {{ "STATE" | translate }}: <span class="badge badge-{{ row.color_step }}">{{ row.label_step | translate }} {{ row.data.date ? _utilService.formatDate(row.data.date, "DD/MM/YYYY HH:mm") : null }}</span>
                </div>
                <div class="col-12">
                  {{ "DATE" | translate }}: <span>{{ _utilService.formatDate(row.data.insert_date) }}</span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
